import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { exportLevel3Thunk, getLevel3Thunk, setLevel3Refresh, setLevel3SubcategoryPage } from '../../../redux/level3/getAllLevel3slice';
import { toast } from 'react-toastify';
import api from '../../../utils/api';
import MasterHeader from '../../../component/reusable/MasterHeader';
import { exportDataExcel, fomateDate } from '../../../utils/fomateDate';
import LevelTable from '../../../component/levelComps/LevelTable';

const Level = () => {



  const { level3, loading, refresh, exportLoading,page } = useSelector((state) => state.level3);
  const [statuss, setStatus] = useState("");
  const [search, setSearch] = useState('')
  // const [page, setPage] = useState(1)
  const [limit, setLimit] = useState(25)
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const [sortBy, setSortyBy] = useState('name');
  const [order, setOrder] = useState('asc');




  const level3categories = level3?.data
  const totalPages = level3?.totalPages
  const totalItems = level3?.totalItems
  const itemsPerPage = level3?.limit

  // calculate start & end of items -------------------
  const start = (page - 1) * limit + 1;
  const end =
    totalPages === page
      ? totalItems
      : (page - 1) * limit + limit;



  useEffect(() => {
    dispatch(getLevel3Thunk(`?search=${search}&page=${page}&status=${statuss}&limit=${limit}&sortBy=${sortBy}&order=${order}`));
  }, [page, search, statuss, limit, refresh,sortBy,order]);



  const handleFileChange = async (e) => {
    try {
      const file = e.target.files[0];
      if (!file) return;

      const formData = new FormData();
      formData.append('file', file);

      const response = await api.addBulklevel3Category(formData);
      if (response.data) {
        toast.success(response?.data?.data?.message)
        dispatch(setLevel3Refresh());
      }
    } catch (err) {
      console.log(err);
      toast.error(err?.response?.data?.message || 'Something went wrong')
    }
  };

  const exportData = async () => {
    const data = await dispatch(exportLevel3Thunk())

    if (data?.payload?.success === true) {
      const subcategoriesdata = data?.payload?.data
  
      
      const exportdata = subcategoriesdata?.map((item) => ({
        'name': item?.name || '-',
        'description': item?.description,
        'categoryName': item?.category?.name,
        'subcategoryName': item?.subcategory?.name,
        // 'cover_image': item?.cover_image?.map(i => i)?.join(', ') || '-',
        // 'thumbnail_photo': item?.thumbnail?.photo?.map(i => i)?.join(', ') || '-',
        'variant_name': item?.atributes?.map(i => i)?.join(', ') || '',
        'thumbnail_status': item?.thumbnail?.status,
        'createdAt': fomateDate(item?.createdAt),
      }))
      exportDataExcel(exportdata, "level3")
    }
  }


  const handleOpenMenu = (sort) => {
    setSortyBy(sort)
    setOrder((prevOrder) => (prevOrder === 'asc' ? 'desc' : 'asc'));
  };


  return (
    <div style={{}}>

      <MasterHeader
        index="Subcategory Level 3"
        root="Dashboard"
        setStatus={setStatus}
        setSearch={setSearch}
        handleFileChange={handleFileChange}
        onClickadd={() => navigate('/master/addLevel')}
        buttonText={'Add Level 3 data'}
        exportData={exportData}
        exportLoading={exportLoading}
      />


      {loading ?
        <div>
          Please wait...
        </div>
        :
        <>
          {
            level3categories?.length > 0 ?
              <LevelTable
                level3={level3categories}
                itemsPerPage={itemsPerPage}
                start={start}
                end={end}
                setPage={setLevel3SubcategoryPage}
                totalItems={totalItems}
                page={page}
                handleOpenMenu={handleOpenMenu}
              />
              :
              <div>
                No level3 categories found
              </div>
          }
        </>
      }
    </div>
  );
};

export default Level;
